<script>
export default {
  props: ['value'],
  render (h) {
    return h('button', {
      attrs: { type: 'button' },
      class: { '-active': this.value },
      on: { click: () => this.$emit('input', !this.value) },
    }, this.$slots.default);
  },
};
</script>
